
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/avatar/avatar.component.js'
      import type { DdsClickEvent } from '../../events/events'
import type { DdsLoadEvent } from '../../events/events'
import type { DdsErrorEvent } from '../../events/events'
      export type { DdsClickEvent } from '../../events/events'
export type { DdsLoadEvent } from '../../events/events'
export type { DdsErrorEvent } from '../../events/events'

      const tagName = 'dap-ds-avatar'

      /**
 * `dap-ds-avatar`
 * @summary Avatar component can be used to display user profile images, initials, or icons.
 * @element dap-ds-avatar
 * @title - Avatar
 *
 * @slot icon - The icon to display when variant is 'icon'.
 * @slot fallback - Custom fallback content when image fails to load.
 *
 * @event dds-click - Fired when the avatar is clicked (only when interactive).
 * @event dds-load - Fired when the image loads successfully.
 * @event dds-error - Fired when the image fails to load.
 *
 * @csspart base - The main avatar container.
 * @csspart img - The avatar image.
 * @csspart initials - The initials container.
 * @csspart icon - The icon container.
 * @csspart fallback - The fallback content container.
 * @csspart loading - The loading indicator.
 *
 * @cssproperty --dds-avatar-border-radius - The border radius of the avatar. Default varies by shape.
 * @cssproperty --dds-avatar-background-color - The background color of the avatar. Default is neutral.
 * @cssproperty --dds-avatar-border-width - The width of the avatar's border. Default is 0.
 * @cssproperty --dds-avatar-border-color - The color of the avatar's border. Default is transparent.
 * @cssproperty --dds-avatar-border-style - The style of the avatar's border. Default is solid.
 * @cssproperty --dds-avatar-transition - The transition property for the avatar. Default is 'all 0.2s ease-in-out'.
 * @cssproperty --dds-avatar-text-color - The color of initials text. Default is neutral strong.
 * @cssproperty --dds-avatar-font-size - The font size for initials. Calculated based on size.
 * @cssproperty --dds-avatar-font-weight - The font weight for initials. Default is semibold.
 *
 * @cssproperty --dds-avatar-size-lg - The size of the large avatar. Default is 80px.
 * @cssproperty --dds-avatar-size-md - The size of the medium avatar. Default is 64px.
 * @cssproperty --dds-avatar-size-sm - The size of the small avatar. Default is 48px.
 * @cssproperty --dds-avatar-size-xs - The size of the extra small avatar. Default is 32px.
 * @cssproperty --dds-avatar-size-xxs - The size of the extra extra small avatar. Default is 24px.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsClick: 'dds-click' as EventName<DdsClickEvent>,
onDdsLoad: 'dds-load' as EventName<DdsLoadEvent>,
onDdsError: 'dds-error' as EventName<DdsErrorEvent>
        },
        displayName: "DapDSAvatar"
      })

      export default reactWrapper
    